import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";

const EFFECTIVE_DATE = "February 14, 2026";

const DmcaPolicyPage = () => {
  return (
    <div className="min-h-screen" style={{ background: "#1a1a1e" }} data-testid="dmca-page">
      <div className="border-b border-gray-800" style={{ background: "#0f0f11" }}>
        <div className="container-custom py-4">
          <Link to="/"><Button variant="ghost" className="text-purple-400" data-testid="dmca-back">← Back</Button></Link>
        </div>
      </div>
      <div className="container-custom py-12">
        <div className="max-w-4xl mx-auto">
          <Card className="p-8" style={{ background: "rgba(42, 26, 58, 0.5)", borderColor: "rgba(138, 43, 226, 0.3)" }}>
            <h1 className="text-4xl font-bold text-white mb-2">Copyright / DMCA Policy</h1>
            <p className="text-sm text-purple-300 mb-8">Effective Date: {EFFECTIVE_DATE}</p>
            <div className="space-y-6 text-gray-300 leading-relaxed">
              <p>
                RGM Studio respects the intellectual property rights of others and expects users of the
                platform to do the same. We respond to clear notices of alleged copyright infringement
                that comply with the U.S. Digital Millennium Copyright Act (DMCA) and similar laws.
              </p>

              <h2 className="text-2xl font-bold text-white">Filing a Copyright Notice</h2>
              <p>If you believe content on RGM Studio infringes your copyright, please send a notice that includes:</p>
              <ul className="list-disc pl-6 space-y-1">
                <li>Your contact information (name, email, address, phone).</li>
                <li>A description of the copyrighted work you believe has been infringed.</li>
                <li>The URL or location of the infringing material on RGM Studio.</li>
                <li>A statement that you have a good-faith belief that the use is not authorised by the copyright owner, its agent, or the law.</li>
                <li>A statement, under penalty of perjury, that the information in your notice is accurate and that you are the copyright owner or authorised to act on their behalf.</li>
                <li>Your physical or electronic signature.</li>
              </ul>

              <h2 className="text-2xl font-bold text-white">Counter-Notification</h2>
              <p>If your content was removed and you believe this was a mistake or misidentification, you may submit a counter-notification including your contact information, identification of the removed material, and a statement under penalty of perjury that the removal was a mistake or misidentification.</p>

              <h2 className="text-2xl font-bold text-white">Repeat Infringers</h2>
              <p>RGM Studio will terminate accounts of users who are repeat infringers.</p>

              <h2 className="text-2xl font-bold text-white">Designated Agent / Contact</h2>
              <p>📧 <a className="text-purple-300 underline" href="mailto:realglobalmusicent@yahoo.com">realglobalmusicent@yahoo.com</a></p>
              <p>Please include "DMCA Notice" in the subject line.</p>
            </div>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default DmcaPolicyPage;
